import 'firebase/firestore';
import 'firebase/auth';
import keys from './keys';

// Initialize Firebase
const FirebaseConfig = {
    apiKey: keys.firebase.apiKey,
    authDomain: keys.firebase.authDomain,
    databaseURL: keys.firebase.databaseURL,
    projectId: keys.firebase.projectId,
    storageBucket: keys.firebase.storageBucket,
    messagingSenderId: keys.firebase.messagingSenderId,
};

export default FirebaseConfig;